<div
    class="section-wrapper is-header"
    [class.is-header]="isHeader()"
    [class.is-estate]="!isHeader()"
    [class.collapsed]="!showDetails()" 
    [class.in-market]="searchViewOptions().periodDefinitionType === periodType.InMarket"
>
    @if (searchViewOptions().periodDefinitionType !== periodType.Registered && showDetails()) {
        <div class="count-row count-separator counter-spacing">
            <div class="flex-coloumn">
                <div class="flex-coloumn">
                    <div class="primary-color uppercase-text">Registrert</div>
                    <div class="secondary-color uppercase-text">i perioden</div>
                </div>
                <div class="big-number">{{ statistics().registeredInPeriod | thousandize }}</div>
            </div>
            <div class="flex-coloumn">
                <div class="flex-coloumn">
                    <div class="primary-color uppercase-text">Registrert</div>
                    <div class="secondary-color uppercase-text">før perioden</div>
                </div>
                <div class="big-number">{{ statistics().registeredBeforePeriod | thousandize }}</div>
            </div>
        </div>
    }
    <div class="count-card" [class.top]="showDetails()">
        @if (showDetails()) {
            <div class="count-row top">
                <div class="primary-color">Snitt prisantydning</div>
            </div>
        }
        <div class="count-row">
            <div class="secondary-color">m² BRA-i/P-rom</div>
            <div class="primary-color">{{ statistics().squareMeterPriceAssumption | thousandize }}</div>
        </div>
        <div class="count-row">
            <div class="secondary-color">m² BRA</div>
            <div class="primary-color">{{ statistics().squareMeterPriceBraPriceAssumption | thousandize }}</div>
        </div>
        <div class="count-row" [class.last-row]="searchViewOptions().periodDefinitionType !== periodType.Sold && (showDetails() || isHeader())">
            <div class="secondary-color">Prisantydning</div>
            <div class="primary-color">{{ statistics().averagePriceAssumption | thousandize }}</div>
        </div>
        @if (statistics().changedPriceAssumption !== undefined) {
            <div class="count-row">
                <div class="secondary-color">Ant. med endret prisant.</div>
                <div class="primary-color">{{ statistics().changedPriceAssumption | thousandize }}</div>
            </div>
        }
    </div>
</div>
